export default "__VITE_ASSET__BFNrAFBU__"